import { EventFacetName, eventsListUrlStateSchema } from "@libry-content/common";
import { useMultipleUrlStates } from "../../utils/hooks/useMultipleUrlStates/useMultipleUrlStates";

export type DateFilter = "to" | "from";

export const useEventsListUrlState = () => {
  const [urlState, updateState] = useMultipleUrlStates(eventsListUrlStateSchema);

  const loadMoreEvents = () =>
    updateState({
      pagination: (urlState?.pagination || 1) + 1,
    });

  const toggleFacet = (facet: EventFacetName, value: string) => {
    const currentFacet = urlState?.[facet] || [];
    const isSelected = currentFacet.includes(value);

    updateState({
      [facet]: !isSelected ? [...currentFacet, value] : currentFacet.filter((filter) => filter !== value),
      pagination: undefined,
    });
  };

  const setDateFilter = (dateFilter: DateFilter, date: string | undefined) => {
    updateState({
      [dateFilter]: date,
      pagination: undefined,
    });
  };

  return {
    urlState,
    toggleFacet,
    loadMoreEvents,
    setDateFilter,
  };
};
